export default function () {
    return {
        subscriptions: [],
        selectedLevel: null,
        subscriptionSuccess: false,
    }
}